import React from 'react';
import Drawer from './Drawer.jsx';
import Rimg from './Rimg.jsx';
import ProductContext from './ProductContext.jsx';
import SVG from './SVG.jsx';
import { formatMoney } from '@shopify/theme-currency';
import MediaQuery from 'react-responsive';
import FitFinderForm from './FitFinderForm.jsx';
import trackEvent from '../utils/trackEvent';
import SizeGuide from './SizeGuide.jsx';
import ImageZoom from '../components/ImageZoom.js';

const sanitizeHtml = html => {
  const tempEl = document.createElement('div');
  tempEl.innerHTML = html;
  return { __html: tempEl.innerHTML }
}

class HonestPricing extends React.PureComponent {
  constructor(props) {
    super();
    this.state = { open: false };

    this._close = this._close.bind(this);
  }

  _close() {
    this.setState({ open: false })
  }

  render() {
    const DrawerHeading = <React.Fragment>
      {this.props.checkmark && <svg className="svg-icon icon-check" xmlns="http://www.w3.org/2000/svg">
        <use xlinkHref="#reuse-check"></use>
      </svg>}
      <div className="promo-heading-inline" dangerouslySetInnerHTML={sanitizeHtml(this.props.drawer_heading)} />
    </React.Fragment>
    return <React.Fragment>
      <div className="product-block-honest_pricing">
        <a className="promo-heading" onClick={(e) => { this.setState({ open: true }) }}>
          {this.props.checkmark && <svg className="svg-icon icon-check" xmlns="http://www.w3.org/2000/svg">
            <use xlinkHref="#reuse-check"></use>
          </svg>}
          <div className="promo-heading-inline" dangerouslySetInnerHTML={sanitizeHtml(this.props.heading)} />
        </a>
      </div>
      <Drawer open={this.state.open} content={this.props.drawer_content} heading={DrawerHeading} contentClass="pricing-philosophy pricing-philosophy-how-we-do-it afterpay-drawer" _close={this._close} mountOnEnter={true} unmountOnExit={true}>
        {this.props.metafields.philosophy.inlineImage &&
          <React.Fragment>
            <Rimg {...this.props.metafields.philosophy.inlineImage} loading="lazy" className="pricing-philosophy-img" sizes="336px" />
            <SVG icon="pricing-philosophy" />
          </React.Fragment>}
      </Drawer>
    </React.Fragment>
  }
}

class HonestPricing2 extends React.PureComponent {
  constructor(props) {
    super();
    this.state = { open: false };

    this._close = this._close.bind(this);
  }

  _close() {
    this.setState({ open: false })
  }

  render() {
    const DrawerHeading = <React.Fragment>
      {this.props.checkmark && <svg className="svg-icon icon-check" xmlns="http://www.w3.org/2000/svg">
        <use xlinkHref="#reuse-check"></use>
      </svg>}
      <div className="promo-heading-inline" dangerouslySetInnerHTML={sanitizeHtml(this.props.drawer_heading)} />
    </React.Fragment>
    return <React.Fragment>
      <div className="product-block-honest_pricing_2">
        <div className="promo-heading" onClick={(e) => { this.setState({ open: true }) }}>
          {[1, 2, 3].map(x => {
            const icon = this.props[`icon_${x}`];
            return <div className="honest_pricing_heading" key={x}>
              {icon && <svg className={`svg-icon icon-${icon}`} xmlns="http://www.w3.org/2000/svg">
                <use xlinkHref={`#reuse-${icon}`}></use>
              </svg>}
              {this.props[`heading_${x}`] && <div className="promo-heading-inline" dangerouslySetInnerHTML={sanitizeHtml(this.props[`heading_${x}`])} />}
            </div>
          })}
        </div>
      </div>
      {this.props.drawer_content &&
        <Drawer open={this.state.open} content={this.props.drawer_content} heading={DrawerHeading} contentClass="pricing-philosophy pricing-philosophy-how-we-do-it afterpay-drawer" _close={this._close} mountOnEnter={true} unmountOnExit={true}>
          {this.props.metafields.philosophy.inlineImage &&
            <React.Fragment>
              <Rimg {...this.props.metafields.philosophy.inlineImage} loading="lazy" className="pricing-philosophy-img" sizes="336px" />
              <SVG icon="pricing-philosophy" />
            </React.Fragment>}
        </Drawer>
      }
    </React.Fragment>
  }
}

class FindMySizeHome extends React.PureComponent {
  constructor(props) {
    super();

    this.videoRef = React.createRef();
  }

  componentDidMount() {
    if (this.videoRef.current) {
      this.videoRef.current.addEventListener('play', () => {
        trackEvent('SizeVideoPlay', {
          vendor: this.props.product.vendor,
          handle: this.props.product.handle,
        });
      })
    }
  }

  render() {
    // Access translations from window.themeStrings
    const t = window.themeStrings || {};
    
    return <React.Fragment>
      <div className="header-wrap">
        <div className="header-line-wrap">
          <SVG icon="ruler" className="sizing-ruler" />
          <h1 className="title">{t.find_my_size_title || 'Find My Size'}</h1>
        </div>
      </div>
      <p className="rte fms-intro">
        {t.find_my_size_intro || 'Need help finding the right size? Select an option below to get started.'}
      </p>
      {!this.props.product.tags.includes('no_quiz') &&
        <section className="find-my-size-option rte">
          <h4 className="find-my-size-option-heading">
            {t.find_my_size_fit_finder_heading || 'Take the Fit Finder Quiz (Recommended)'}
          </h4>
          <p>{t.find_my_size_fit_finder_description || "Tell us what size(s) you normally wear and we'll use data from real customers to give you the best recommendation possible."}</p>
          <button className="text-button" onClick={() => this.props._setScreen('fitFinder')}>
            {t.find_my_size_take_quiz || 'Take the quiz'} &gt;
          </button>
        </section>
      }
      {this.props.sizeGuides.short_size_guide_html &&
        <section className="find-my-size-option size-guide rte">
          <h4 className="find-my-size-option-heading">
            {t.find_my_size_size_guide_heading || 'Size Guide'}
          </h4>
          <div dangerouslySetInnerHTML={sanitizeHtml(this.props.sizeGuides.short_size_guide_html)} />
          <button className="text-button" onClick={() => this.props._setScreen('sizeGuide')}>
            {t.find_my_size_view_details || 'View more details'} &gt;
          </button>
        </section>
      }
      {this.props.metafields.measurements &&
        <section className="find-my-size-option measurement-table rte">
          <div class="find-my-size-measurements">
            <h4 className="find-my-size-option-heading">
              {t.find_my_size_measurements_heading || 'Measurements + International Conversion'}
            </h4>
            <p>{t.find_my_size_measurements_description || 'If you prefer to measure your foot or need to convert from an international size, take a look at our measurement table.'}</p>
          </div>
          <div class="find-my-size-measurements-alt">
            <h4 className="find-my-size-option-heading">
              {t.find_my_size_international_heading || 'International Sizing'}
            </h4>
            <p>{t.find_my_size_international_description || 'Need to convert from an international size? Take a look at our conversion table.'}</p>
          </div>
          <button className="text-button" onClick={() => this.props._setScreen('measurements')}>
            {t.find_my_size_see_table || 'See the table'} &gt;
          </button>
        </section>
      }
      {this.props.metafields.size_video &&
        <section className="find-my-size-option rte">
          <h4 className="find-my-size-option-heading">
            {t.find_my_size_video_guide_heading || 'Video Guide'}
          </h4>
          <video playsInline controls className="sizing-video" poster={this.props.metafields.size_video.preview_image.src} width={this.props.metafields.size_video.preview_image.width} height={this.props.metafields.size_video.preview_image.height} ref={this.videoRef}>
            {this.props.metafields.size_video.sources.slice(0).reverse().map((source, i) =>
              <source type={source.mime_type} height={source.height} width={source.width} src={source.url} key={i} />
            )}
          </video>
        </section>
      }
      <section className="find-my-size-option rte">
        <p className="rte find-my-size-contact first" 
           dangerouslySetInnerHTML={{__html: t.find_my_size_free_shipping_returns || 'We offer <b>free shipping and returns</b> in the contiguous US, so you can give us a try without stress.'}}>
        </p>
        <p className="rte find-my-size-contact" 
           dangerouslySetInnerHTML={{__html: t.find_my_size_need_help || 'Need a second opinion? <a href="/pages/email-us" title="Contact Us">Text, email, or call us</a> and we\'ll be happy to assist you.'}}>
        </p>
      </section>
    </React.Fragment>
  }
}

class FindMySize extends React.PureComponent {
  constructor(props) {
    super();
    this.state = { open: false, screen: 'home' };
    this._openSizeGuide = this._openSizeGuide.bind(this);
    this._close = this._close.bind(this);
    this._setScreen = this._setScreen.bind(this);
    this.drawerRef = React.createRef();
  }

  _openSizeGuide(e) {
    e.preventDefault();

    trackEvent('Opened Find My Size', { handle: this.props.product.handle, vendor: this.props.product.vendor });

    this.setState({ open: true });
  }

  _close() {
    this.setState({ open: false, screen: 'home' })
  }

  _setScreen(screen) {
    this.setState({ screen })
    if (this.drawerRef.current) {
      this.drawerRef.current.scrollToTop();
    }
  }

  render() {
    return <React.Fragment>
      <a href="#" onClick={this._openSizeGuide}>{this.context.i18n.fitFinderTrigger}</a>
      <Drawer open={this.state.open} className="fit-guide" _close={this._close} mountOnEnter={true} unmountOnExit={true} ref={this.drawerRef}>
        {this.state.screen === 'home' && <FindMySizeHome product={this.props.product} metafields={this.props.metafields} sizeGuides={this.props.sizeGuides} _setScreen={this._setScreen} />}
        {this.state.screen === 'fitFinder' && <FitFinderForm product={this.props.product} _optionChanged={this.props._optionChanged} closeFitFinder={this._close} _openSizeGuide={this.props._openSizeGuide} />}
        {this.state.screen === 'sizeGuide' && <SizeGuide _setScreen={this._setScreen}>
          <div className="header-wrap">
            <div className="header-line-wrap">
              <SVG icon="ruler" className="sizing-ruler" />
              <h1 className="title">Sizing Guide</h1>
            </div>
            <button className="text-button uc-title back-button" onClick={() => this._setScreen('home')}>&lt; Back</button>
          </div>
          <div dangerouslySetInnerHTML={sanitizeHtml(this.props.sizeGuides.size_guide_html)} />
        </SizeGuide>}
        {this.state.screen === 'measurements' && <ProductMeasurements metafields={this.props.metafields} _setScreen={this._setScreen} />}
      </Drawer>
    </React.Fragment>
  }
}

FindMySize.contextType = ProductContext;

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // You can also log the error to an error reporting service
    console.error(error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      // You can render any custom fallback UI
      return <div>
        <h1>Something went wrong.</h1>
        <button className="text-button" onClick={() => {
          this.props._resetForm()
          this.setState({ hasError: false })
        }}>Try again</button>
      </div>
    }

    return this.props.children;
  }
}

class FitFinder extends React.PureComponent {
  constructor(props) {
    super();
    this.state = { open: false, key: 0 };
    this._openFitFinder = this._openFitFinder.bind(this);
    this._close = this._close.bind(this);
    this._resetForm = this._resetForm.bind(this);
  }

  _openFitFinder(e) {
    e && e.preventDefault();

    trackEvent('Opened Quiz', { handle: this.props.product.handle, vendor: this.props.product.vendor });

    this.setState({ open: true });
  }

  _close() {
    this.setState({ open: false })
  }

  _resetForm() {
    this._close();
    this.setState({ key: this.state.key + 1 });
    setTimeout(() => {
      this._openFitFinder();
    }, 350)
  }

  render() {
    return <React.Fragment>
      <a href="#" onClick={this._openFitFinder}>{this.context.i18n.fitFinderTrigger}</a>
      <Drawer open={this.state.open} _close={this._close} mountOnEnter={true} unmountOnExit={false}>
        <ErrorBoundary _resetForm={this._resetForm}>
          <FitFinderForm product={this.props.product} _optionChanged={this.props._optionChanged} closeFitFinder={this._close} _openSizeGuide={this.props._openSizeGuide} key={this.state.key} />
        </ErrorBoundary>
      </Drawer>
    </React.Fragment>
  }
}

FitFinder.contextType = ProductContext;

/* class SizeGuide extends React.PureComponent {
  constructor(props) {
    super();
    this.state = { open: false };
    this._open = this._open.bind(this);
    this._close = this._close.bind(this);
  }

  _open(e) {
    e.preventDefault();

    this.setState({ open: true });
  }

  _close() {
    this.setState({ open: false });
  }

  render() {
    return <React.Fragment>
      <a href="#" onClick={this._open}>{this.context.i18n.sizeGuideTrigger}</a>
      <Drawer open={this.state.open} content={this.props.sizeGuideHtml} _close={this._close} mountOnEnter={false} unmountOnExit={true} />
    </React.Fragment>
  }
} */

const ProductMeasurements = (props) => {
  let numberOfRows = 0;
  let numberOfColumns = 0;
  for (let i = 1; i < 6; i++) {
    if (props.metafields.measurements[`column_${i}_label`] && props.metafields.measurements[`column_${i}_label`].length > 0) {
      numberOfColumns++;
    }
  }
  for (const key in props.metafields.measurements) {
    if (Array.isArray(props.metafields.measurements[key]) && props.metafields.measurements[key].length > numberOfRows) {
      numberOfRows = props.metafields.measurements[key].length;
    }
  }
  return <React.Fragment>
    <div className="header-wrap">
      <div className="header-line-wrap">
        <SVG icon="ruler" className="sizing-ruler" />
        <h1 className="title">Size Measurements</h1>
      </div>
      <button className="text-button uc-title back-button" onClick={() => props._setScreen('home')}>&lt; Back</button>
    </div>
    <table className="product-measurements">
      <thead>
        <tr>
          {Array(numberOfColumns).fill().map((_, i) => {
            return <th key={i}>{props.metafields.measurements[`column_${i + 1}_label`]}</th>
          })}
        </tr>
      </thead>
      <tbody>
        {Array(numberOfRows).fill().map((_, i) => {
          return <tr key={i}>
            {Array(numberOfColumns).fill().map((_, j) => {
              return <td key={j}>{props.metafields.measurements[`column_${j + 1}_values`][i]}</td>
            })}
          </tr>
        })}
      </tbody>
    </table>
  </React.Fragment>
}

class Measurements extends React.PureComponent {
  constructor(props) {
    super();

    this.fitFinderTrigger = this.fitFinderTrigger.bind(this);
    this.icon = this.icon.bind(this);
  }

  fitFinderTrigger() {
    if (this.props.fit_finder_trigger) {
      return <FindMySize product={this.props.product} metafields={this.props.metafields} sizeGuides={this.props.sizeGuides} _openSizeGuide={this.props._openSizeGuide} _optionChanged={this.props._optionChanged} />
    } else if (this.props.fit_finder_trigger_2) {
      return <FitFinder product={this.props.product} _openSizeGuide={this.props._openSizeGuide} _optionChanged={this.props._optionChanged} />
    } else if (this.props.measurement_trigger && this.props._openSizeGuide) {
      return <a href="#" onClick={this.props._openSizeGuide}>{this.context.i18n.sizeGuideTrigger}</a>
    } else if (this.props.measurement_trigger && this.props._openFitGuide) {
      return <a href="#" onClick={this.props._openFitGuide}>{this.context.i18n.fitGuideTrigger}</a>
    }
    return null;
  }

  icon() {
    if (this.props.position === 'above-atc') {
      <SVG icon="ruler" />
    }
    return null
  }

  render() {
    if (!this.props.heading) {
      return null;
    }
    return <div className={`product-block product-block-measurements product-block-position-${this.props.position}`} id={`product-block-${this.props.id}`}>
      <this.icon />
      <div className="product-block-inline size-text" dangerouslySetInnerHTML={{ __html: this.props.heading }} />
      {' '}
      <this.fitFinderTrigger />
    </div>
  }
}

Measurements.contextType = ProductContext;

class WairSizingChart extends React.PureComponent {
  constructor(props) {
    super();

    this.fitFinderTrigger = this.fitFinderTrigger.bind(this);
    this.icon = this.icon.bind(this);
  }

  fitFinderTrigger() {
    if (this.props.fit_finder_trigger) {
      return <FindMySize product={this.props.product} metafields={this.props.metafields} sizeGuides={this.props.sizeGuides} _openSizeGuide={this.props._openSizeGuide} _optionChanged={this.props._optionChanged} />
    } else if (this.props.fit_finder_trigger_2) {
      return <FitFinder product={this.props.product} _openSizeGuide={this.props._openSizeGuide} _optionChanged={this.props._optionChanged} />
    } else if (this.props.measurement_trigger && this.props._openSizeGuide) {
      return <a href="#" onClick={this.props._openSizeGuide}>{this.context.i18n.sizeGuideTrigger}</a>
    } else if (this.props.measurement_trigger && this.props._openFitGuide) {
      return <a href="#" onClick={this.props._openFitGuide}>{this.context.i18n.fitGuideTrigger}</a>
    }
    return null;
  }

  icon() {
    if (this.props.position === 'above-atc') {
      <SVG icon="ruler" />
    }
    return null
  }

  render() {
    if (!this.props.heading) {
      return null;
    }
    return (
      <div className='wair-sizing-chart'>
        <Wair product={this.props.product} promo={this.props.promo} position={this.props.position} _optionChanged={this.props._optionChanged} key={this.props.key} showIcon={true} />
        <div className={`product-block product-block-measurements product-block-position-${this.props.position}`} id={`product-block-${this.props.id}`}>
          <svg xmlns="http://www.w3.org/2000/svg" xlink="http://www.w3.org/1999/xlink" width="32" height="32" viewBox="0 0 323 323">
            <defs>
              <clipPath id="clip-Arrows">
                <rect width="323" height="323" />
              </clipPath>
            </defs>
            <g id="Arrows" clip-path="url(#clip-Arrows)">
              <g id="Group_6" data-name="Group 6" transform="translate(-203.69 170.412) rotate(-45)">
                <g id="Group_2" data-name="Group 2" transform="translate(0.653 -2)">
                  <g id="Group_1" data-name="Group 1">
                    <line id="Line_1" data-name="Line 1" y1="78" x2="78" transform="translate(193.5 34.5)" fill="none" stroke="#000" stroke-width="21" />
                    <line id="Line_2" data-name="Line 2" y1="78" x2="78" transform="translate(334.5 34.5) rotate(90)" fill="none" stroke="#000" stroke-width="21" />
                    <rect id="Rectangle_1" data-name="Rectangle 1" width="24" height="166" transform="translate(252 49)" />
                  </g>
                </g>
                <g id="Group_3" data-name="Group 3" transform="translate(10.75 516) rotate(-90)">
                  <g id="Group_1-2" data-name="Group 1">
                    <line id="Line_1-2" data-name="Line 1" y1="78" x2="78" transform="translate(193.5 34.5)" fill="none" stroke="#000" stroke-width="21" />
                    <line id="Line_2-2" data-name="Line 2" y1="78" x2="78" transform="translate(334.5 34.5) rotate(90)" fill="none" stroke="#000" stroke-width="21" />
                    <rect id="Rectangle_1-2" data-name="Rectangle 1" width="24" height="166" transform="translate(252 49)" />
                  </g>
                </g>
                <g id="Group_4" data-name="Group 4" transform="translate(517.25 -12) rotate(90)">
                  <g id="Group_1-3" data-name="Group 1">
                    <line id="Line_1-3" data-name="Line 1" y1="78" x2="78" transform="translate(193.5 34.5)" fill="none" stroke="#000" stroke-width="21" />
                    <line id="Line_2-3" data-name="Line 2" y1="78" x2="78" transform="translate(334.5 34.5) rotate(90)" fill="none" stroke="#000" stroke-width="21" />
                    <rect id="Rectangle_1-3" data-name="Rectangle 1" width="24" height="166" transform="translate(252 49)" />
                  </g>
                </g>
                <g id="Group_5" data-name="Group 5" transform="translate(528.653 505.5) rotate(180)">
                  <g id="Group_1-4" data-name="Group 1">
                    <line id="Line_1-4" data-name="Line 1" y1="78" x2="78" transform="translate(193.5 34.5)" fill="none" stroke="#000" stroke-width="21" />
                    <line id="Line_2-4" data-name="Line 2" y1="78" x2="78" transform="translate(334.5 34.5) rotate(90)" fill="none" stroke="#000" stroke-width="21" />
                    <rect id="Rectangle_1-4" data-name="Rectangle 1" width="24" height="166" transform="translate(252 49)" />
                  </g>
                </g>
              </g>
            </g>
          </svg>
          <this.fitFinderTrigger />
        </div>
      </div>
    )
  }
}

WairSizingChart.contextType = ProductContext;

class ReviewsSummary extends React.PureComponent {
  constructor(props) {
    super();
  }

  scrollToReviews() {
    const yotpoEl = document.querySelector('.product-feature-reviews');
    if (yotpoEl) {
      yotpoEl.scrollIntoView({ behavior: 'smooth' });
    }
  }

  render() {
    const fillWidth = this.props.metafields.yotpo.reviewsAverage * 20;
    if (!this.props.metafields.yotpo) {
      return null;
    }
    return <div className={`product-block product-block-position-${this.props.position}`}>
      <div className="yotpo-star-container" onClick={this.scrollToReviews}>
        <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" width="87" height="15" viewBox="0 0 87 15" version="1.1" className="review-stars">
          <g>
            <rect className="stars-fill-light" width="87" height="15"></rect>
            <rect className="stars-fill" width="87" height="15" style={{ width: fillWidth + '%' }}></rect>
            <use xlinkHref="#reuse-stars" className="icon-stars"></use>
          </g>
        </svg>
        {' '}
        <span className="yotpo-content">{this.props.metafields.yotpo.reviewsAverage} ({formatMoney(this.props.metafields.yotpo.reviewsCount * 100, '{{amount_no_decimals}}')} reviews)</span>
      </div>
    </div>
  }
}

ReviewsSummary.contextType = ProductContext;

class ReturnsPolicy extends React.PureComponent {
  constructor(props) {
    super();
    this.state = { open: false };

    this._close = this._close.bind(this);
  }

  _close() {
    this.setState({ open: false })
  }

  render() {
    const DrawerHeading = <React.Fragment>
      {this.props.checkmark && <svg className="svg-icon icon-check" xmlns="http://www.w3.org/2000/svg">
        <use xlinkHref="#reuse-check"></use>
      </svg>}
      <div className="promo-heading-inline" dangerouslySetInnerHTML={sanitizeHtml(this.props.drawer_heading)} />
    </React.Fragment>
    return <React.Fragment>
      <div className="product-block-return_policy">
        <a className="promo-heading" onClick={(e) => { this.setState({ open: true }) }}>
          {this.props.checkmark && <svg className="svg-icon icon-check" xmlns="http://www.w3.org/2000/svg">
            <use xlinkHref="#reuse-check"></use>
          </svg>}
          <div className="promo-heading-inline" dangerouslySetInnerHTML={sanitizeHtml(this.props.heading)} />
        </a>
      </div>
      <Drawer open={this.state.open} content={this.props.drawer_content} heading={DrawerHeading} contentClass="pricing-philosophy pricing-philosophy-how-we-do-it afterpay-drawer" _close={this._close} mountOnEnter={true} unmountOnExit={true}>
      </Drawer>
    </React.Fragment>
  }
}

const Wair = function (props) {
  React.useEffect(() => {
    const wairLoaded = (event) => {
      event.detail.predict.render({
        brandKey: window.Shopify.shop,
        product: {
          key: props.product.handle,
          name: props.product.title,
          image: props.product.featured_image,
        },
        "onRecommendCallback": (variantId) => {
          const recommendation = props.product.variants.find(v => `${v.id}` === `${variantId}`);
          if (recommendation) {
            recommendation.options.forEach((option, i) => {
              props._optionChanged(`option${i + 1}`, option);
            })
          }
        }
      })
    }
    window.addEventListener("onPredictLoad", wairLoaded);

    return () => {
      window.removeEventListener("onPredictLoad", wairLoaded);
    }
  }, [])

  return (
    <div className={`product-block product-block-wair product-block-position-${props.position} ${props.promo.custom_class}`} key={props.product.id} style={{ minHeight: 46, minWidth: 195, borderRadius: 6, marginRight: '' }}>
      {props.showIcon && <SVG icon="ruler" className="sizing-ruler" />}
      <div className="predict-placement" data-predict-product-key={props.product.handle} data-predict-product-name={props.product.title} data-predict-product-img={props.product.featured_image} />
    </div>
  )
}

class VideoCarousel extends React.PureComponent {
  constructor(props) {
    super();

    this.ref = React.createRef();

    this.imageZoom = null;

    this._openImageZoom = this._openImageZoom.bind(this);
  }

  _openImageZoom(id, el) {
    if (!this.imageZoom) {
      const imageZoomMedia = this.props.metafields.custom.video_carousel.map(src => {
        if (src.media_type == 'video') {
          const videoSources = src.sources.sort((a, b) => b.height - a.height);
          let htmlString = `<video class="pswp-video" playsInline width="${videoSources[0].width}" height="${videoSources[0].height}">`;
          videoSources.map((src) => {
            htmlString += `<source type="${src.mime_type}" height="${src.height}" width="${src.width}" src="${src.url}"></source>`
          });

          htmlString += '</video>'

          return {
            "id": src.id,
            "html": htmlString
          }
        }
        return {
          "id": src.id,
          "w": src.width,
          "h": src.height,
          "src": src.src
        }
      });

      this.imageZoom = new ImageZoom(imageZoomMedia, {
        autoProgress: 5000, onVideoPlay: (src) => {
          trackEvent('PlayVideoCarousel', {
            vendor: this.props.product.vendor,
            handle: this.props.product.handle,
            title: this.props.product.title,
            videoSrc: src
          });
        }
      });
    }

    this.imageZoom.open(id, el);
  }

  render() {
    const props = this.props;

    return <div className="product-block product-block-video_carousel">
      <div className="promo-heading" dangerouslySetInnerHTML={sanitizeHtml(props.heading)} />
      <div className="video-carousel">
        {props.metafields.custom.video_carousel.length > 4 &&
          <MediaQuery minWidth={720}>
            <button className="video-carousel-scroll-left video-carousel-scroll-button" onClick={() => {
              this.ref.current.scrollBy({ top: 0, left: (-1 * this.ref.current.clientWidth / 4), behavior: 'smooth' });
            }}>
              <SVG icon="arrow-thin-left" />
            </button>
          </MediaQuery>
        }
        <div className="video-carousel-content" ref={this.ref}>
          {props.metafields.custom.video_carousel.map((video, i) => {
            return <div className="video-carousel-slide" key={i}>
              <div className="video-carousel-image-wrap">
                <Rimg {...video.preview_image} loading="lazy" className="video-carousel-image" sizes="(min-width: 1555px) 145w, (min-width: 720px) 11vw, 25vw" onClick={(e) => this._openImageZoom(video.id, e.currentTarget)} data-image-zoom={video.id} maxWidth={video.preview_image.width} minWidth={144} />
                <SVG icon="play" className="video-carousel-play" />
              </div>
              {video.alt && <div className="video-carousel-caption">{video.alt}</div>}
            </div>
          })}
        </div>
        {props.metafields.custom.video_carousel.length > 4 &&
          <MediaQuery minWidth={720}>
            <button className="video-carousel-scroll-right video-carousel-scroll-button" onClick={() => {
              this.ref.current.scrollBy({ top: 0, left: (this.ref.current.clientWidth / 4), behavior: 'smooth' });
            }}>
              <SVG icon="arrow-thin-right" />
            </button>
          </MediaQuery>
        }
      </div>
    </div>
  }
}

class PromoText extends React.PureComponent {
  constructor(props) {
    super();
    this.state = { open: false };

    this._close = this._close.bind(this);
  }

  _close() {
    this.setState({ open: false })
  }

  render() {
    return <div className={`product-block product-block-promo_text product-block-position-${this.props.position} ${this.props.custom_class}`}>
      <div className="promo-heading" dangerouslySetInnerHTML={sanitizeHtml(this.props.heading)} />
      <div className="promo-subheading">
        <span dangerouslySetInnerHTML={sanitizeHtml(this.props.subheading)} />
        {this.props.drawer_button && <button className="text-button" onClick={(e) => { this.setState({ open: true }) }}>{this.props.drawer_button}</button>}
      </div>
      <Drawer open={this.state.open} content={this.props.drawer_content} heading={this.props.drawer_heading} _close={this._close} mountOnEnter={true} unmountOnExit={true}>
      </Drawer>
    </div>
  }
}

class Anagram extends React.PureComponent {
  constructor(props) {
    super();
    this.rootRef = React.createRef();
    this.scriptLoaded = false;
    this.uniqueId = `anagram-root-${props.id || Math.random().toString(36).substr(2, 9)}`;
  }

  componentDidMount() {
    // Add CSS link to head if not already added (only once globally)
    if (!document.querySelector('link[href="https://unpkg.com/@anagram-ai/engagement/index.css"]')) {
      const link = document.createElement('link');
      link.rel = 'stylesheet';
      link.type = 'text/css';
      link.href = 'https://unpkg.com/@anagram-ai/engagement/index.css';
      document.head.appendChild(link);
    }

    // Execute the script
    if (this.rootRef.current && !this.scriptLoaded) {
      const script = document.createElement('script');
      script.type = 'module';
      script.crossOrigin = 'anonymous';
      
      const productTitle = this.props.product?.title || '';
      const productId = this.props.product?.id || '';
      const pageHandle = this.props.product?.handle || window.location.pathname.split('/').filter(Boolean).pop() || '';
      const templateName = 'product';
      
      script.textContent = `
        import { renderAnagram } from "https://unpkg.com/@anagram-ai/engagement/index.js"
        const elementToAttachTo = document.querySelector("#${this.uniqueId}");
        renderAnagram(
          "a92a9b8f-eb36-4aab-ade1-8efb6f5b753f",
          elementToAttachTo,
          {
            productTitle: ${JSON.stringify(productTitle)},
            originOfInquiry: ${JSON.stringify(productTitle || pageHandle || templateName)},
            sourceProductId: ${JSON.stringify(String(productId))},
            pageHandle: ${JSON.stringify(pageHandle || templateName)},
            styleOptions: {
              "root": {
                "width": "100%",
                "height": "100%",
                "paddingTop": "0px",
                "paddingRight": "0px",
                "paddingBottom": "0px",
                "paddingLeft": "0px",
                "backgroundColor": "rgba(0, 0, 0, 0)",
                "mobile": {
                  "paddingTop": "0px",
                  "paddingRight": "0px",
                  "paddingBottom": "0px",
                  "paddingLeft": "0px"
                }
              },
              "oneClickQuestions": {
                "minHeight": "0",
                "backgroundColor": "rgba(0, 0, 0, 0.05)",
                "borderWidth": "0px",
                "borderColor": "rgba(0, 0, 0, 0)",
                "borderRadius": "0px",
                "fontFamily": "Nunito Sans, sans-serif",
                "fontSize": "14px",
                "lineHeight": "1.5",
                "fontWeight": "500",
                "fontColor": "rgba(107, 114, 128, 1)",
                "iconSize": "20px",
                "paddingTop": "8px",
                "paddingBottom": "8px",
                "paddingLeft": "12px",
                "paddingRight": "12px",
                "hoverStyles": {
                  "backgroundColor": "rgba(0, 0, 0, 0.1)",
                  "color": "rgba(75, 85, 99, 1)"
                }
              },
              "launcher": {
                "minHeight": "47px",
                "borderColor": "rgba(156, 163, 175, 0.9)",
                "borderWidth": "1px",
                "borderRadius": "0px",
                "input": {
                  "placeholderFontColor": "rgba(100, 116, 139, 1)",
                  "placeholderText": "Ask a question...",
                  "backgroundColor": "rgba(0, 0, 0, 0)",
                  "fontFamily": "Nunito Sans, sans-serif",
                  "fontSize": "14px",
                  "lineHeight": "1.25",
                  "fontWeight": "400",
                  "fontColor": "rgba(0, 0, 0, 0.75)",
                  "maxWidth": "100%",
                  "paddingTop": "12px",
                  "paddingBottom": "12px",
                  "paddingLeft": "12px",
                  "paddingRight": "12px"
                },
                "button": {
                  "text": "ASK AI",
                  "backgroundColor": "#205f83",
                  "fontFamily": "Nunito Sans, sans-serif",
                  "fontSize": "14px",
                  "lineHeight": "1.50",
                  "fontWeight": "600",
                  "fontColor": "rgba(248, 250, 252, 1)",
                  "iconSize": "24px",
                  "paddingTop": "8px",
                  "paddingBottom": "8px",
                  "paddingLeft": "16px",
                  "paddingRight": "16px",
                  "hoverStyles": {
                    "backgroundColor": "rgba(18, 18, 18, 0.90)"
                  }
                },
                "maxWidth": "100%",
                "marginTop": "0px",
                "marginRight": "0px",
                "marginBottom": "0px",
                "marginLeft": "0px",
                "mobile": {
                  "maxWidth": "100%",
                  "marginTop": "0px",
                  "marginRight": "0px",
                  "marginBottom": "0px",
                  "marginLeft": "0px"
                }
              },
              "dialog": {
                "root": {
                  "borderRadius": "0px",
                  "mobile": {
                    "offsetBottom": "0px"
                  }
                },
                "userMessage": {
                  "iconSize": "32px",
                  "fontFamily": "Nunito Sans, sans-serif",
                  "fontSize": "24px",
                  "lineHeight": "1.50",
                  "fontWeight": "600",
                  "fontColor": "rgba(0, 0, 0, 0.9)"
                },
                "responseMessage": {
                  "fontFamily": "Nunito Sans, sans-serif",
                  "fontSize": "15px",
                  "lineHeight": "1.625",
                  "fontWeight": "400",
                  "fontColor": "rgba(0, 0, 0, 0.9)"
                },
                "launcher": {
                  "minHeight": "47px",
                  "borderColor": "rgba(156, 163, 175, 0.9)",
                  "borderWidth": "1px",
                  "borderRadius": "0px",
                  "input": {
                    "placeholderFontColor": "rgba(100, 116, 139, 1)",
                    "placeholderText": "Ask a question...",
                    "backgroundColor": "rgba(0, 0, 0, 0)",
                    "fontFamily": "Nunito Sans, sans-serif",
                    "fontSize": "16px",
                    "lineHeight": "1.25",
                    "fontWeight": "400",
                    "fontColor": "rgba(0, 0, 0, 0.75)",
                    "maxWidth": "100%",
                    "paddingTop": "12px",
                    "paddingBottom": "12px",
                    "paddingLeft": "12px",
                    "paddingRight": "12px"
                  },
                  "button": {
                    "text": "ASK AI",
                    "backgroundColor": "#205f83",
                    "fontFamily": "Nunito Sans, sans-serif",
                    "fontSize": "16px",
                    "lineHeight": "1.50",
                    "fontWeight": "600",
                    "fontColor": "rgba(248, 250, 252, 1)",
                    "iconSize": "24px",
                    "paddingTop": "8px",
                    "paddingBottom": "8px",
                    "paddingLeft": "16px",
                    "paddingRight": "16px",
                    "hoverStyles": {
                      "backgroundColor": "rgba(18, 18, 18, 0.90)"
                    }
                  }
                }
              }
            }
          }
        );
      `;
      
      this.rootRef.current.appendChild(script);
      this.scriptLoaded = true;
    }
  }

  render() {
    return (
      <div className={`product-block product-block-anagram product-block-position-${this.props.position}`}>
        <div id={this.uniqueId} className="anagram-style" ref={this.rootRef}></div>
      </div>
    );
  }
}

export default class ProductPromos extends React.PureComponent {
  constructor(props) {
    super();
    this.promos = props.blocks.filter(promo => {
      if ((promo.settings.position === 'above-atc-smart' || promo.settings.position === 'above-atc-smart-2' || promo.settings.position === 'above-atc-smart-3') && props.position === 'above-atc' && props.product.options.size === 0) {
        return true;
      }
      return promo.settings.position === props.position
    });
  }

  render() {
    return this.promos.map((promo, i) => {
      const mediaAttr = {}

      if (promo.settings.desktop === 'hide' && promo.settings.mobile === 'hide') {
        return (null)
      } else if (promo.settings.desktop === 'hide') {
        mediaAttr.maxWidth = 719;
      } else if (promo.settings.mobile === 'hide') {
        mediaAttr.minWidth = 720;
      } else {
        mediaAttr.minWidth = 0;
      }

      switch (promo.type) {
        case "promo_text":
          return <MediaQuery {...mediaAttr} key={i}>
            <PromoText key={i} {...promo.settings} position={this.props.position} />
          </MediaQuery>
        case "wair":
          this.context.loadWair();
          return <Wair product={this.props.product} promo={promo} position={this.props.position} _optionChanged={this.props._optionChanged} key={i} />
        case "video_carousel":
          return <MediaQuery {...mediaAttr} key={i}>
            <VideoCarousel {...promo.settings} metafields={this.props.metafields} product={this.props.product} />
          </MediaQuery>
        case "honest_pricing":
          return <MediaQuery {...mediaAttr} key={i}>
            <HonestPricing {...promo.settings} metafields={this.props.metafields} />
          </MediaQuery>
        case "honest_pricing_2":
          return <MediaQuery {...mediaAttr} key={i}>
            <HonestPricing2 {...promo.settings} metafields={this.props.metafields} />
          </MediaQuery>
        case "reviews":
          return <MediaQuery {...mediaAttr} key={i}>
            <ReviewsSummary {...promo.settings} metafields={this.props.metafields} />
          </MediaQuery>
        case "return_policy":
          return <MediaQuery {...mediaAttr} key={i}>
            <ReturnsPolicy {...promo.settings} metafields={this.props.metafields} />
          </MediaQuery>
        case "measurements":
          return <MediaQuery {...mediaAttr} key={i}>
            <Measurements {...promo.settings} product={this.props.product} metafields={this.props.metafields} _openSizeGuide={this.props._openSizeGuide} _openFitGuide={this.props._openFitGuide} _optionChanged={this.props._optionChanged} sizeGuides={this.props.sizeGuides} />
          </MediaQuery>
        case "wair_sizing_chart":
          this.context.loadWair(); // Load Wair data
          return <WairSizingChart {...promo.settings} product={this.props.product} metafields={this.props.metafields} _openSizeGuide={this.props._openSizeGuide} _openFitGuide={this.props._openFitGuide} _optionChanged={this.props._optionChanged} sizeGuides={this.props.sizeGuides} position={this.props.position} key={i} promo={promo} />
        case "anagram":
          return <MediaQuery {...mediaAttr} key={i}>
            <Anagram {...promo.settings} product={this.props.product} position={this.props.position} />
          </MediaQuery>
        default:
          return null;
      }
    })
  }
}

ProductPromos.contextType = ProductContext;
